import {Injectable} from '@angular/core';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {ParametrosCobrosAuto} from '../../models/cobrosAutoservicio/parametrosCobrosAuto';
import {moduloCobrosAutoservicio} from '../../diccionarios/cobrosAutoServiciosModulo';

@Injectable({
  providedIn: 'root'
})
export class CobrosAutoserviciosService {

  cobrosAutoModulo: any;
  urlGlobal: string;
  urlGlobalRecaudacion: string;
  urlDatosMaestros: string;

  constructor(private _util: UtilsService,
              private _commom: CommonService) {
    this.urlDatosMaestros = this._util.getDatosMaestros();
    this.cobrosAutoModulo = moduloCobrosAutoservicio;
    this.urlGlobal = this._util.getFinanciero(this.cobrosAutoModulo.url.cobrosAutoservicios.cobrosAutoservicios + this.cobrosAutoModulo.url.cobrosAutoservicios.paramCobrosAutoserv);
    this.urlGlobalRecaudacion = this._util.getFinanciero(this.cobrosAutoModulo.url.cobrosAutoservicios.cobrosAutoservicios + this.cobrosAutoModulo.url.cobrosAutoservicios.recaudacionCliente);
  }

  getAll() {
    // http://172.25.4.31:8084/qrks/v1/financiero/api/service/cobros-autoserv/param
    // http://172.25.4.31:8084/qrks/v1/financiero/api/service/cobros-autoserv/param-cobros-autoserv
    return this._commom.peticionGetConHeader(this.urlGlobal);
  }

  guardarParametros(inObjeto: ParametrosCobrosAuto) {
    return this._commom.peticionPostConHeader(this.urlGlobal, inObjeto);
  }

  actualizarParametros(inObjeto: ParametrosCobrosAuto) {
    return this._commom.peticionPutConHeader(this.urlGlobal, inObjeto);
  }

  eliminarParametros(innId: string) {
    return this._commom.peticionDeleteConHeader(this.urlGlobal + this.cobrosAutoModulo.url.parametros.idParametro + innId);
  }

  getTipoPago() {
    return this._commom.peticionGetConHeader(this.urlDatosMaestros + this.cobrosAutoModulo.url.datosMaestros.viaPago);
  }

  getClienteVinculado(idCliente: string) {
    // debugger
    // let u = this.urlGlobalRecaudacion + this.cobrosAutoModulo.url.cobrosAutoservicios.clienteVinculado + idCliente;
    // console.log(u);
    return this._commom.peticionGetConHeader(this.urlGlobalRecaudacion + this.cobrosAutoModulo.url.cobrosAutoservicios.clienteVinculado + idCliente);
  }

  getCliente(idCliente: string) {
    return this._commom.peticionGetConHeader(this.urlDatosMaestros + this.cobrosAutoModulo.url.datosMaestros.cliente + idCliente);
  }

  procesarArchivo(inObjeto: any) {
    return this._commom.peticionPostConHeader(this.urlGlobalRecaudacion + this.cobrosAutoModulo.url.cobrosAutoservicios.uploadFile, inObjeto);
  }

  reprocesarArchivo(inObjeto: any) {
    return this._commom.peticionPostConHeader(this.urlGlobalRecaudacion + this.cobrosAutoModulo.url.cobrosAutoservicios.processData, inObjeto);
  }

  guardarCobros(inObjeto: any) {
    return this._commom.peticionPostConHeader(this.urlGlobalRecaudacion + this.cobrosAutoModulo.url.cobrosAutoservicios.saveCollection, inObjeto);
  }

  getAllCobros() {
    // http://172.25.4.31:8084/qrks/v1/financiero/api/service/cobros-autoserv/recaudacion/cabecera
    return this._commom.peticionGetConHeader(this.urlGlobalRecaudacion + this.cobrosAutoModulo.url.cobrosAutoservicios.getAutoServCabe);
  }

  getAllCobrosDetalles(idCobroAutoserv: any) {
    return this._commom.peticionGetConHeader(this.urlGlobalRecaudacion + this.cobrosAutoModulo.url.cobrosAutoservicios.findCobrosAutoServDeta + idCobroAutoserv);
  }

  descargarReciboCobro(idCobroAutoserv: any) {
    return this._commom.peticionGetConHeader(this.urlGlobalRecaudacion + this.cobrosAutoModulo.url.cobrosAutoservicios.getPDF + idCobroAutoserv + '/1');
  }

  descargarEstadoDocumentos(idCobroAutoserv: any) {
    return this._commom.peticionGetConHeader(this.urlGlobalRecaudacion + this.cobrosAutoModulo.url.cobrosAutoservicios.getPDF + idCobroAutoserv + '/2');
  }

  cargarClaveBanco(inIdEmpresa: string, inIdBanco: string) {
    return this._commom.peticionGetConHeader(this._util.getFinanciero(this.cobrosAutoModulo.url.conciliacionBancaria.conciBanc)
      + this.cobrosAutoModulo.url.parametros.idEmpresa + inIdEmpresa
      + this.cobrosAutoModulo.url.parametros.idBanco + inIdBanco,);
  }

}
